var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CurrencyRupee, Percent } from '@mui/icons-material';
import React from 'react';
import { PlusHeaderIcon } from '../../../assets/customIcons';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { getByIdAPI } from '../../../redux/crudSlice';
import { useAppDispatch } from '../../../store/hooks';
import { ContractSaleOrderKeys, GetServiceContractDetailsURL } from '../services/entity';
var ContractDetailsDrawer = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var dispatch = useAppDispatch();
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '16px 20px',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Contract details',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary[600]",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '20px',
            columnSize: 12,
            spacing: 0,
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    border: '1px solid',
                    borderColor: 'secondary.200',
                    borderRadius: '12px',
                    padding: '16px',
                    gap: '12px',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Code',
                                    columnSize: 0,
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    color: 'secondary.600',
                                    valueGetter: function (formValues) {
                                        return "#".concat(formValues === null || formValues === void 0 ? void 0 : formValues.Code);
                                    }
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: '',
                                    label: 'New',
                                    size: 'small',
                                    color: 'primary',
                                    shape: 'rounded',
                                    columnSize: 0
                                }]
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Name',
                            columnSize: 12,
                            fontSize: 'lg',
                            fontWeight: 'medium',
                            valueGetter: function (formValues, field) {
                                return "Contract name - ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.Name);
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 's',
                            value: 'SAC Code:',
                            fontWeight: 'medium',
                            columnSize: 3,
                            color: 'secondary.600',
                            fontSize: 'sm',
                            mt: '2px'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'SacCode',
                            value: null,
                            fontWeight: 'medium',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Description',
                            columnSize: 12,
                            color: 'secondary.600',
                            valueGetter: function (formValues, field) {
                                return "Description text- ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.Description);
                            }
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'OdometerReading',
                            label: 'Odometer  ',
                            columnSize: 12,
                            placeholder: 'Enter odometer reading'
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Rate',
                            label: 'Amount  ',
                            value: null,
                            columnSize: 12,
                            disabled: true,
                            InputProps: {
                                startAdornment: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                    sx: {
                                        color: 'secondary.500',
                                        height: '16px',
                                        width: '16px'
                                    }
                                }),
                                style: {
                                    textAlignLast: 'end'
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            alignItems: 'end',
                            elements: [{
                                    type: FormItemTypes.NumberInput,
                                    name: 'DiscountPercentage',
                                    label: 'Discount',
                                    value: null,
                                    columnSize: 5,
                                    disabled: true,
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ React.createElement(Percent, {
                                            sx: {
                                                color: 'secondary.500',
                                                height: '16px',
                                                width: '16px'
                                            }
                                        })
                                    }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: 'DiscountAmount',
                                    label: '  ',
                                    value: null,
                                    columnSize: 7,
                                    placeholder: 'Enter discount',
                                    InputProps: {
                                        startAdornment: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                            sx: {
                                                color: 'secondary.500',
                                                height: '16px',
                                                width: '16px'
                                            }
                                        }),
                                        style: {
                                            textAlignLast: 'end'
                                        }
                                    },
                                    disabled: true
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 12,
                            borderRadius: '8px',
                            padding: '12px',
                            bgcolor: 'background.default',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Box,
                                sx: {
                                    display: state !== null && state !== void 0 && state.RenewalEligibilityConditions ? undefined : 'none'
                                }
                            }); },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Renew conditions',
                                    fontWeight: 'strong',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'RenewalEligibilityConditions',
                                    fontSize: 'sm',
                                    color: 'secondary.600',
                                    columnSize: 12
                                }]
                        }
                        //Return conditions 
                        // {
                        //     type: FormItemTypes.Box,
                        //     name: '',
                        //     columnSize: 12,
                        //     borderRadius: '8px',
                        //     padding: '12px',
                        //     bgcolor: 'background.default',
                        //     display: 'flex',
                        //     flexDirection: 'column',
                        //     gap: '10px',
                        //     elements: [
                        //         {
                        //             type: FormItemTypes.Typography,
                        //             name: '',
                        //             children: 'Return conditions',
                        //             fontWeight: 'strong',
                        //             columnSize: 12,
                        //         },
                        //         {
                        //             type: FormItemTypes.Divider,
                        //             name: '',
                        //             variant: 'fullWidth',
                        //             columnSize: 12,
                        //         },
                        //         {
                        //             type: FormItemTypes.Custom,
                        //             name: '',
                        //             columnSize: 12,
                        //             element: () =>
                        //                 <ol style={{ paddingLeft: '12px', fontSize: 'sm', color: 'secondary.600' }}>
                        //                     <li>Return is allowed in 45 days after the invoiced date</li>
                        //                     <li>Contract should not be consumed</li>
                        //                 </ol>
                        //         }
                        //     ],
                        // }
                    ]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            paddingInline: '24px',
            columnSize: 12,
            padding: '24px',
            spacing: 0,
            gap: '12px',
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        spacing: 0,
                        height: "5px"
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    direction: 'row',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'ContractPrice',
                            columnSize: 0,
                            fontSize: 'lg',
                            fontWeight: 'strong',
                            valueGetter: function (formValues) {
                                var _formValues$ContractP;
                                return "\u20B9 ".concat((_formValues$ContractP = formValues === null || formValues === void 0 ? void 0 : formValues.ContractPrice) !== null && _formValues$ContractP !== void 0 ? _formValues$ContractP : 0);
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'contained',
                            children: 'Add',
                            columnSize: 0,
                            onClick: function () { return 'submit'; },
                            startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null)
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0,
            sx: {
                paddingTop: {
                    sx: 0,
                    sm: 0,
                    md: '60px',
                    lg: '60px'
                }
            }
        },
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); },
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _res$payload, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                            key: ContractSaleOrderKeys.GetServiceContractDetails,
                            url: GetServiceContractDetailsURL(data === null || data === void 0 ? void 0 : data.ChildId),
                            request: {}
                        }))];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, {
                                success: true,
                                data: _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data), data)
                            }];
                }
            });
        }); },
        getKey: ContractSaleOrderKeys.GetServiceContractDetails,
        formData: formData,
        mode: "edit"
    }));
};
export default ContractDetailsDrawer;
